import { createBrowserRouter, Navigate, RouteObject } from "react-router-dom";
import App from "../layout/App";
// import Gov from "../layout/gov/Gov";
import ChatDomain from "../layout/chatbot/ChatDomain";
import SignInCallback from "../layout/SignInCallback";
import SignOutCallback from "../layout/SignOutCallback";
import DoctorOnboarding from "../layout/onboarding/DoctorOnboarding";
import PatientSpace from "../layout/patient/PatientSpace";
import CaseBlocksRenderer from "../layout/cases/CaseBlocksRenderer";
// import ChatInteractions from "../layout/chatbot/ChatInteractions";
import { useParams } from "react-router-dom";
import Dashboard from "../../features/home/Dashboard";
// import CasesSpace from "../layout/cases/CaseSpace"; // Removed - functionality merged into CaseImageGallery
import CaseImageGallery from '../layout/images/CaseImageGallery';
import CaseDetection from "../layout/images/CaseDetection";
import ReportPreview from "../layout/cases/components/ReportPreview";
import EpidemiologyAnalytics from "../layout/analytics/EpidemiologyAnalytics";
import CaseDetailsView from "../layout/cases/CaseDetailsView";
// import MoleDetection from "../layout/images/MoleDetection";
// import AnnotationPage from "../layout/images/AnnotationPage";
import AccountManagement from "../layout/account/AccountManagement";
import RequireAdmin from "./RequireAdmin";

const CaseWrapper = () => {
  const { id } = useParams();
  return <CaseBlocksRenderer caseId={id || ""} />;
};

const CaseDetectionWrapper = () => {
  const { caseId } = useParams();
  
  return <CaseDetection caseId={caseId || ""} />;
};
export const routes: RouteObject[]=[
    
    
    {
        path:'/',
        element:<App/>,
        children:[ 
          // 🎉 ALL ROUTES OPEN - Subscription only limits image uploads (15 free)
            {path:'/', element:<Dashboard/>},
            {path:"/signin-oidc", element:<SignInCallback/>},
            {path:"/signout-callback-oidc", element:<SignOutCallback/>},
            {path:'/account', element:<AccountManagement/>},

            // ✅ Core features - FREE ACCESS (15 image limit enforced by backend)
            {path:"/patients", element:<PatientSpace/>},
            {path:'ChatDomain',element:<ChatDomain/>},
            {path:'ChatDomain/:uuid',element:<ChatDomain/>},
            {path:'images',element:<CaseImageGallery/>},
            {path:'images/:caseId',element:<CaseDetectionWrapper />},
            {path:"/cases/:id", element:<CaseWrapper />},
            {path:"/cases/:id/report-preview", element:<ReportPreview />},
            {path:"/cases/:caseId/details", element:<CaseDetailsView />},
            {path:"/report-preview/:reportId", element:<ReportPreview />},
            
            // ✅ Advanced features - FREE ACCESS (no subscription gates!)
            {path:'/DoctorOnboarding',element:<DoctorOnboarding/>},
            {path:'/EpidemiologyAnalytics',element:<EpidemiologyAnalytics/>},

            // 🔒 Admin-only section (unchanged)
            {
              element: <RequireAdmin />,
              children: [
                // Add admin-only routes here
              ]
            },

            // not-found
            {path:'*', element:<Navigate replace to='/'/>}
        ]
    }
];

export const router =createBrowserRouter(routes);

